import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Grid, Avatar, Menu, MenuItem } from '@mui/material';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';

import { RoutesMap } from 'src/const';
import { KPI_CARD_COLOR } from 'src/colors';
import userIcon from 'src/App/assets/userIcon.png';
import { getTokenThunk } from 'src/store/Auth/actions';
import CurrencyChangeMenu from '../../../CurrencyChangeMenu';
import { clearApiCache } from 'src/utils/functions';
import { useOpenOverviewOnboardingPage } from 'src/utils/hooks';

const UserMenu = ({
  logoutThunk,
  user,
  handleMarketSidebarClick,
  currency,
  setCurrency,
  setLoginModalOpen,
  centerCoord,
  address,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [userNameInitials, setUserNameInitials] = useState('');
  const history = useHistory();
  const isLoggedIn = getTokenThunk()();
  const openOverviewOnboardingPage = useOpenOverviewOnboardingPage();

  const handleClick = ({ currentTarget }) => {
    setAnchorEl(currentTarget);
    localStorage.setItem('saw-webinar-link-on-avatar', 'true');
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLoginLogout = async () => {
    if (isLoggedIn) {
      logoutThunk();
      await clearApiCache();
      history.push(RoutesMap.Home);
    } else {
      localStorage.setItem('estimatorCoords', JSON.stringify(centerCoord));
      localStorage.setItem('estimatorAddress', address);
      setLoginModalOpen(true);
    }
  };

  let userName = user && user.userName;
  if (!userName) {
    userName = 'Trial';
  }

  const getUserInitials = name => {
    const nameArray = name.split(' ');
    if (nameArray.length === 1) {
      return nameArray[0].slice(0, 2).toUpperCase();
    } else if (nameArray.length > 1) {
      const firstNameInitial = nameArray[0][0]?.toUpperCase();
      const lastNameInitial = nameArray[nameArray.length - 1][0]?.toUpperCase();
      return `${firstNameInitial}${lastNameInitial ? lastNameInitial : ''}`;
    } else {
      return '';
    }
  };

  useEffect(() => {
    if (user.userName != 'Trial') {
      let userNameInitials = getUserInitials(user.userName);
      setUserNameInitials(userNameInitials);
    }
  }, [user]);

  return (
    <Grid item>
      <Avatar
        sx={{
          width: 46,
          height: 46,
          cursor: 'pointer',
          backgroundColor: KPI_CARD_COLOR,
          color: '#ffff',
          fontSize: '25px',
        }}
        onClick={handleClick}
        src={userNameInitials == '' ? userIcon : ''}
      >
        {userNameInitials}
      </Avatar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '10px',
          },
        }}
      >
        <MenuItem onClick={() => openOverviewOnboardingPage()}>
          <AccountCircleIcon sx={{ marginRight: '3px' }} />
          Your Account
        </MenuItem>
        <MenuItem onClick={handleLoginLogout}>
          <LogoutIcon sx={{ marginRight: '3px' }} />
          {isLoggedIn ? 'Log out' : 'Log In'}
        </MenuItem>
        <MenuItem style={{ padding: '0px' }}>
          <CurrencyChangeMenu currency={currency} setCurrency={setCurrency} fullWidth={true} />
        </MenuItem>
      </Menu>
    </Grid>
  );
};

export default UserMenu;
